package uz.ferro.shop.model

import kotlinx.serialization.Serializable

@Serializable
data class FilterGroupFilterSet(
    val id: Long?,
    val filterSet: FilterSet?,
    var sort: Int = 0
)